import cookieAndLocalStorage from "../../helpers/cookieAndLocalStorage";

const HR_REPORTS_FETCH = 'reports/hr/FETCH';
const HR_REPORTS_FETCH_SUCCESS = 'reports/hr/FETCH_SUCCESS';
const HR_REPORTS_FETCH_FAIL = 'reports/hr/FETCH_FAIL';

const MANAGER_REPORTS_FETCH = 'reports/manager/FETCH';
const MANAGER_REPORTS_FETCH_SUCCESS = 'reports/manager/FETCH_SUCCESS';
const MANAGER_REPORTS_FETCH_FAIL = 'reports/manager/FETCH_FAIL';

const EMPLOYEE_REPORTS_FETCH = 'reports/employee/FETCH';
const EMPLOYEE_REPORTS_FETCH_SUCCESS = 'reports/employee/FETCH_SUCCESS';
const EMPLOYEE_REPORTS_FETCH_FAIL = 'reports/employee/FETCH_FAIL';
const CLEAR_STATE = 'CLEAR_STATE';

const initialState = {
  reportsData: ''
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case HR_REPORTS_FETCH:
      return {
        ...state,
        loading: true
      };
    case HR_REPORTS_FETCH_SUCCESS:
      return {
        ...state,
        reportsData: action.result.data,
        loading: false

      };
    case HR_REPORTS_FETCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error.data
      };

    case MANAGER_REPORTS_FETCH:
      return {
        ...state,
        loading: true
      };
    case MANAGER_REPORTS_FETCH_SUCCESS:
      return {
        ...state,
        reportsData: action.result.data,
        loading: false

      };
    case MANAGER_REPORTS_FETCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error.data
      };
    case EMPLOYEE_REPORTS_FETCH:
      return {
        ...state,
        loading: true
      };
    case EMPLOYEE_REPORTS_FETCH_SUCCESS:
      return {
        ...state,
        reportsData: action.result.data,
        loading: false

      };
    case EMPLOYEE_REPORTS_FETCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error.data
      };

    case CLEAR_STATE:
      return {
        ...initialState
      };
    default:
      return state;
  }
}

export function clearReportState() {
  return {
    type: CLEAR_STATE
  };
}
export function fetchHrReports(payload) {
  return {
    types: [HR_REPORTS_FETCH, HR_REPORTS_FETCH_SUCCESS, HR_REPORTS_FETCH_FAIL],
    payload,
    loading: true,
    promise: client => client.post('/harcirah/reports/hr', { data: payload })
  };
}
export function fetchManagerReports(payload) {
  return {
    types: [MANAGER_REPORTS_FETCH, MANAGER_REPORTS_FETCH_SUCCESS, MANAGER_REPORTS_FETCH_FAIL],
    payload,
    loading: true,
    promise: client => client.post('/harcirah/reports/manager', { data: payload })
  };
}
export function fetchEmployeeReports(payload) {
  return {
    types: [EMPLOYEE_REPORTS_FETCH, EMPLOYEE_REPORTS_FETCH_SUCCESS, EMPLOYEE_REPORTS_FETCH_FAIL],
    payload,
    loading: true,
    promise: client => client.post('/harcirah/reports/employee', { data: payload })
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/reports.js